import "bootstrap-icons/font/bootstrap-icons.css";

import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";

import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { eligibility } from "constants/eligibility";
import { handleOpenPdf } from "utils";
import ScrollAnimatedProgressBar from "components/progressbar/ScrollAnimatedProgressBar";

import outline_check from "assets/images/outline_check.svg";
import currency from "assets/images/currency_icons.svg";
import ca_table from "assets/images/ca_table_1.svg";
import ca_pdpa from "assets/pdf/deposits/CA_PDPA.pdf";

function CurrentAccount() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Deposits"
          title={`Current
              <span className="jumbotron-subtitle-2">
                account-<em>i</em>
              </span>`}
          buttonText="Talk to us"
          footNotes="Protected by PIDM up to RM250,000 for each depositor"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              If you want a current account that keeps up, an alrajhi bank
              Malaysia Current Account-i fits the bill. Convenient transactional
              account with statements and unlimited cheques. Get a cheque book
              for all your transactions, on top of a special Visa Debit-ATM
              Card-i, accepted at millions of locations worldwide. Enjoy the
              conveniences of a no-frills checking account, with only a RM500
              initial deposit
            </p>
            <img
              style={{ width: "100%" }}
              src="https://www.alrajhibank.com.my/assets/images/currency/currency_logo.svg"
              className="d-inline-block align-top"
              alt="Currency Logo"
            />
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Guaranteed</div>
                <div className="column-subheader">Principle</div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Cheque book</div>
                <div className="column-subheader">
                  alrajhi bank Malaysia chequebook available upon request{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Initial deposit of</div>
                <div className="column-subheader">
                  RM500 (Individual & Non-individual); or<br></br>
                  USD1,000 or its equivalent (Individual)
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Currency</div>
                <div className="column-subheader">
                  Available in MYR & selected foreign currencies
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Qard (loan)</div>
                <div className="column-subheader">Shariah Contract </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">VISA-enabled ATM Card</div>
                <div className="column-subheader-2">
                  Accepted for retail purchase @ 35 million retail outlets
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">e-Statements</div>
                <div className="column-subheader-2">
                  Choice of monthly/quarterly/half-yearly or annual{" "}
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah standards</div>
                <div className="column-subheader-2">
                  Compliance with alrajhi bank Malaysia Shariah standards{" "}
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Protected by PIDM</div>
                <div className="column-subheader-2">
                  Up to RM250,000 for each depositor
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">ATM access</div>
                <div className="column-subheader-2">
                  The operating hours of all alrajhi bank ATMs nationwide are
                  from 06:00am- 11:59pm
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Eligibility</h3>
          </Col>
          <Col md={8}>
            <ScrollAnimatedProgressBar data={eligibility}>
              {eligibility.points.eligibilitycurrent.description.map(
                (benefit, index) => (
                  <div className="animated-list z-1">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </ScrollAnimatedProgressBar>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={ca_table}
              className="d-inline-block align-top"
              alt=""
            />
            <div className="link-button-row">
              <Link to="/tnc" className="w-full">
                <LinkButton text="Terms and Conditions" />
              </Link>
              <Link to="/e-application-form" className="w-full">
                <LinkButton text="e-Application Form" />
              </Link>
              <LinkButton
                text="Personal Data Protection Notice (PDPN)"
                onClick={() => handleOpenPdf(ca_pdpa)}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect! </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
      {/* <MainFooter />
      <SubFooter /> */}
    </div>
  );
}

export default CurrentAccount;
